// extracted by mini-css-extract-plugin
export default {"container":"dashboardContent_container__UcNPW"};